import { useQuery } from '@tanstack/react-query'

import { apiFetch } from './apiFetch'

export const useProject = (projectId) =>
  useQuery({
    queryKey: ['project', projectId],
    queryFn: () => apiFetch(`/api/user/projects/${projectId}`),
    enabled: !!projectId,
    retry: false,
  })
